
import Spinner from "../components/Home/Spinner.js";
import Navbar from "../components/NavBar/NavBar.js";
import Section3 from "../components/Home/Section3.js";
import Section4 from "../components/Home/Section4.js";
import Section5 from "../components/Home/Section5.js";
import Section6 from "../components/Home/Section6.js";
import Section7 from "../components/Home/Section7.js";
import Section8 from "../components/Home/Section8.js";
import Whatsapp from "../components/Home/Whatsapp.js";
import Footer from "../components/Home/Footer.js";
import Accueil from "../components/Services/Accueil.js"
import Metier from "../components/Home/Metier.js"
import { useEffect } from "react";



const Home = () =>{
    useEffect(() => {
  document.title =
    "UNIK SYSTEM | Plafonds Tendus, Acoustique, Éclairage, Solaire & Architecture Textile";

  const meta = document.querySelector("meta[name='description']");
  if (meta) {
    meta.setAttribute(
      "content",
      "UNIK SYSTEM conçoit et installe des solutions architecturales complètes : plafonds et murs tendus, solutions acoustiques, éclairage architectural, protection solaire et architecture textile sur mesure."
    );
  }
}, []);

    return(
        <div className="body">
            <Spinner/>
            <Whatsapp/>
            <Navbar/>
            <Accueil/>
            <Metier/>
            <Section3/>
            <Section8/>
            <Section4/>
            <Section7/>
            <Section5/>
            <Section6/>
            <Footer/>
        </div>
    )
}

export default Home;